{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Розширення Chrome не встановлено.",
      "CTA": "Встановити розширення"
    },
    "STATUS": {
      "OFFLINE": "Телефон офлайн",
      "IN_OTHER_TAB": "Телефон підключено в іншій вкладці",
      "CONNECTING": "Підключення...",
      "DISCONNECTING": "Відключення...",
      "ONLINE": "Телефон онлайн",
      "DIALING": "Набір",
      "TRANSFERRING": "Переадресація...",
      "CONSULTING": "Розмова з агентом",
      "CALLER_ON_HOLD": "Абонент на утриманні",
      "BUSY": "Зайнято",
      "DND": "DND",
      "UNAVAILABLE": "Недоступно",
      "REJECTED": "Виклик відхилено",
      "CALL_FAILED": "Помилка виклику"
    },
    "QUEUES": {
      "MORE": "Інші черги"
    },
    "TABS": {
      "PHONE": "Телефон",
      "SMS": "SMS",
      "HISTORY": "Історія"
    },
    "HISTORY": {
      "OPEN": "Відкриті",
      "RECENT": "Останні",
      "MISSED": "Пропущені",
      "LOADING": "Завантаження дзвінків...",
      "EMPTY": "Дзвінків немає",
      "ERROR": "Не вдалося завантажити дзвінки",
      "CALL": "Передзвонити",
      "CALL_STATUS": {
        "BUTTON": "Встановити статус дзвінка",
        "TITLE": "Статус дзвінка",
        "SEARCH_PLACEHOLDER": "Пошук статусів...",
        "LOADING": "Завантаження статусів...",
        "NO_OPTIONS": "Статуси дзвінків не налаштовані",
        "NO_MATCH": "Статусів не знайдено",
        "OPTIONS_ERROR": "Не вдалося завантажити статуси",
        "RETRY": "Повторити спробу",
        "CONFIRM_QUESTION": "Встановити «{status}» і вирішити розмову?",
        "CONFIRM": "Підтвердити",
        "BACK": "Назад",
        "CANCEL": "Скасувати",
        "SAVING": "Збереження...",
        "SAVE_ERROR": "Не вдалося зберегти статус",
        "RESOLVE_ERROR": "Статус збережено, але не вдалося вирішити розмову"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Номер телефону, напр. +421903000000",
      "BODY_PLACEHOLDER": "Напишіть повідомлення...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Надіслати SMS",
      "SENDING": "Надсилання...",
      "SENT": "SMS надіслано",
      "LOADING": "Завантаження вхідних каналів SMS...",
      "NO_INBOX": "Цей обліковий запис не має вхідного каналу SMS, тому SMS надіслати неможливо.",
      "INVALID_NUMBER": "Введіть номер у міжнародному форматі, включно з + на початку.",
      "ERROR": "Не вдалося надіслати SMS. Спробуйте ще раз."
    },
    "ACTIONS": {
      "CONNECT": "Підключитися",
      "GO_TO_TAB": "Перейти до вкладки",
      "DISCONNECT": "Відключитися",
      "ANSWER": "Відповісти",
      "HANGUP": "Завершити",
      "HOLD": "Утримувати",
      "MUTE": "Вимкнути мікрофон",
      "SILENCE": "Вимкнути звук",
      "TRANSFER": "Переадресувати",
      "COMPLETE_TRANSFER": "Завершити переадресацію",
      "RETURN_TO_CALLER": "Повернутися до абонента",
      "CANCEL_TRANSFER": "Скасувати переадресацію",
      "DIALPAD": "Показати клавіатуру",
      "OPEN_CONVERSATION": "Відкрити розмову"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Вхідний виклик",
      "INCOMING_CALL_FROM": "Вхідний виклик від {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Вхідний виклик від {number}",
      "ANSWER": "Відповісти",
      "DECLINE": "Відхилити"
    },
    "TRANSFER": {
      "TITLE": "Переадресація виклику",
      "PLACEHOLDER": "Введіть номер для переадресації...",
      "SEARCH_PLACEHOLDER": "Пошук агентів...",
      "TARGET_PLACEHOLDER": "Вибраний адресат переадресації",
      "CONFIRM": "Переадресувати",
      "MODE_DIRECT": "Переадресувати одразу",
      "MODE_CONSULT": "Спочатку зателефонувати агенту",
      "CANCEL": "Скасувати"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Ви впевнені, що хочете зробити перерву для всіх черг?",
      "CONFIRM_READY": "Ви впевнені, що хочете повернутися до статусу «готовий» для всіх черг?",
      "CONFIRM_BREAK_QUEUE": "Ви впевнені, що хочете вийти з черги {queue}?",
      "CONFIRM_READY_QUEUE": "Ви впевнені, що хочете увійти до черги {queue}?",
      "LOGIN_TO_QUEUE": "Увійти",
      "LOGOUT_FROM_QUEUE": "Вийти",
      "LOGIN_TO_ALL_QUEUES": "Увійти до всіх черг",
      "LOGOUT_FROM_ALL_QUEUES": "Вийти з усіх черг",
      "OPTION_LOGOUT": "Вийти",
      "OPTION_BREAK": "Перерва",
      "OPTION_LUNCH": "Обід",
      "OPTION_AWAY": "Відсутній",
      "OPTION_DO_NOT_DISTURB": "Не турбувати",
      "OPTION_BUSINESS_TRIP": "Відрядження",
      "CONFIRM": "Підтвердити",
      "CANCEL": "Скасувати"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Немає зв'язку з телефонною системою",
      "MESSAGE": "Схоже, ваше інтернет-з'єднання не працює. Перевірте його та спробуйте ще раз.",
      "CREDENTIALS_TITLE": "Телефонна система відхилила ваші облікові дані",
      "CREDENTIALS_MESSAGE": "Телефонна система відхилила ім’я користувача або пароль, збережені у вашому профілі. Перевірте їх у розділі «Налаштування облікового запису» або зверніться до адміністратора.",
      "CONFIGURATION_TITLE": "Налаштування телефону є недійсними",
      "CONFIGURATION_MESSAGE": "Ім’я користувача SIP або адреса сервера мають недійсний формат, тому телефон не може підключитися. Виправте це в розділі «Налаштування облікового запису».",
      "NETWORK_SHORT": "Помилка з'єднання",
      "CREDENTIALS_SHORT": "Облікові дані відхилено",
      "CONFIGURATION_SHORT": "Недійсні налаштування телефону",
      "RETRY": "Повторити спробу",
      "DISMISS": "Скасувати"
    },
    "CONNECTION_QUALITY": "Якість з'єднання",
    "CONNECTION_QUALITY_EXCELLENT": "Відмінна",
    "CONNECTION_QUALITY_GOOD": "Добра",
    "CONNECTION_QUALITY_FAIR": "Задовільна",
    "CONNECTION_QUALITY_POOR": "Погана",
    "CONNECTION_QUALITY_DISCONNECTED": "Відключено"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Набір номера {number}… Ви можете закрити цю вкладку.",
    "NO_NUMBER": "Номер не вказано. Використовуйте ?number=+380..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Введіть номер телефону...",
    "ACTIONS": {
      "DIAL": "Набрати номер",
      "DIAL_FROM": "Виберіть номер, з якого телефонуєте"
    },
    "DIAL_FROM": {
      "TITLE": "Дзвінок з номера скриньки"
    },
    "VALIDATION": {
      "REQUIRED": "Номер телефону обов'язковий",
      "INVALID_FORMAT": "Недійсний формат номера телефону"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Налаштування та тестування аудіо",
    "SELECT_DEVICE": "Виберіть пристрій...",
    "SYSTEM_DEFAULT": "Системний за замовчуванням",
    "SAVED": "Збережено",
    "DISCONNECTED_SUFFIX": "не підключено",
    "DEVICE_DISCONNECTED": "Вибраний пристрій не підключено. Дзвінки використовують системний пристрій за замовчуванням, доки він не повернеться.",
    "MICROPHONE": {
      "TITLE": "Мікрофон",
      "START_TEST": "Перевірити мікрофон",
      "STOP_TEST": "Зупинити тест",
      "LEVEL": "Рівень:",
      "VERDICT": {
        "LISTENING": "Скажіть щось у мікрофон…",
        "SILENT": "Вас не чути. Перевірте, чи мікрофон увімкнено і чи вибрано правильний.",
        "LOW": "Вас чути лише тихо. Виберіть інший мікрофон або налаштуйте вхідну гучність у налаштуваннях системи.",
        "GOOD": "Гарний звук — вас добре чути."
      }
    },
    "SPEAKER": {
      "TITLE": "Динамік",
      "TEST": "Перевірити динамік",
      "TESTING": "Тестування...",
      "VOLUME": "Гучність:",
      "USING_DEFAULT": "Вибраний вихід недоступний — відтворено через системний пристрій за замовчуванням."
    },
    "DONE": "Готово",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Помилка доступу до мікрофона. Перевірте дозволи.",
      "MICROPHONE_PERMISSION_DENIED": "Доступ до мікрофона заблоковано. Дозвольте його в налаштуваннях сайту у браузері, щоб користуватися телефоном.",
      "MICROPHONE_SILENT": "Ваш мікрофон не вловлює жодного звуку. Перевірте налаштування звуку.",
      "EXTENSION_REQUIRED": "Розширення телефону не виявлено. Установіть або увімкніть його, щоб користуватися мікрофоном.",
      "SPEAKER_TEST": "Помилка перевірки динаміка."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Офлайн",
    "ONLINE": "Онлайн",
    "BUSY": "Зайнято"
  },
  "QUEUE_STATUS": {
    "READY": "Готовий",
    "NOT_READY": "Не приймає виклики",
    "WRAP_UP": "Підсумок",
    "BREAK": "Перерва",
    "LUNCH": "Обід",
    "AWAY": "Відсутній",
    "DO_NOT_DISTURB": "Не турбувати",
    "BUSINESS_TRIP": "Відрядження",
    "OTHER_CALL": "Інший виклик",
    "QUEUE_CALL": "Виклик з черги",
    "OFFLINE": "Офлайн",
    "ONLINE": "Онлайн",
    "NO_ACCESS": "Немає телефону",
    "PARTIALLY_READY": "Частково готовий",
    "MIXED": "Змішаний",
    "CHAT_ONLINE": "Онлайн (чат)",
    "CHAT_BUSY": "Зайнятий (чат)",
    "CHAT_OFFLINE": "Офлайн (чат)"
  }
}
